import React from "react"

const Logotype = () => {
  return (
    <svg
      width="117"
      height="16"
      viewBox="0 0 1156 164"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M159.75 81.5401C159.75 37.0501 196.38 1.07007 242.18 1.07007C288.3 1.07007 324.94 37.0701 324.94 81.5401C324.94 125.7 288.3 162.34 242.18 162.34C196.38 162.34 159.75 125.66 159.75 81.5401ZM285.36 81.5401C285.36 59.3001 266.06 39.6701 242.18 39.6701C218.63 39.6701 199.33 59.3001 199.33 81.5401C199.33 104.11 218.63 123.74 242.18 123.74C266.1 123.74 285.36 104.11 285.36 81.5401Z"
        fill="#0056D2"
      />
      <path
        d="M990.99 82.8501C990.99 34.1101 1030.57 1.07007 1066.56 1.07007C1091.09 1.07007 1105.16 8.59007 1114.64 22.9901L1118.41 3.99007H1155.2V159.39H1118.41L1113.66 143.39C1102.87 155.17 1089.45 162.39 1066.56 162.39C1031.23 162.34 990.99 131.26 990.99 82.8501ZM1116.6 82.5201C1116.56 71.1158 1111.98 60.1959 1103.89 52.1628C1095.79 44.1297 1084.84 39.6413 1073.44 39.6851C1062.03 39.7288 1051.11 44.3011 1043.08 52.3961C1035.04 60.4912 1030.56 71.4458 1030.6 82.8501C1030.6 104.44 1049.9 123.74 1073.46 123.74C1097.31 123.74 1116.6 104.44 1116.6 82.5201V82.5201Z"
        fill="#0056D2"
      />
      <path
        d="M945.78 22.0001V4.00011H905.55V159.39H945.78V75.6601C945.78 50.4701 958.22 37.3901 979.78 37.3901C981.21 37.3901 982.57 37.4901 983.9 37.6201L991.36 0.110107C970.39 0.220107 955.19 7.41011 945.78 22.0001Z"
        fill="#0056D2"
      />
      <path
        d="M541.51 22.01V4.01001L501.28 4.10001L501.62 159.47L541.85 159.38L541.63 75.66C541.57 50.48 553.98 37.37 575.56 37.32C576.937 37.324 578.312 37.4008 579.68 37.55L587.1 0C566.1 0.17 550.88 7.39001 541.51 22.01Z"
        fill="#0056D2"
      />
      <path
        d="M338.88 99.2V4.01001H379.1V94.3C379.1 114.25 390.22 126.03 409.52 126.03C431.11 126.03 443.52 112.94 443.52 87.75V4.01001H483.76V159.39H443.55V141.39C434.07 156.11 418.69 163.31 397.43 163.31C361.45 163.32 338.88 137.15 338.88 99.2Z"
        fill="#0056D2"
      />
      <path
        d="M730.62 81.72C730.71 38.21 761.85 0.979987 811.24 1.06999C857.04 1.15999 889.35 37.85 889.24 81.07C889.248 85.3432 888.914 89.6101 888.24 93.83L769.83 93.61C774.37 112.26 789.72 125.7 812.95 125.75C827.01 125.75 842.07 120.57 851.25 108.81L878.69 130.81C864.58 150.74 839.69 162.47 813.21 162.42C766.46 162.26 730.54 127.19 730.62 81.72ZM848.74 65.58C846.48 49.88 830.15 37.74 810.85 37.71C792.2 37.71 777.14 48.77 771.22 65.44L848.74 65.58Z"
        fill="#0056D2"
      />
      <path
        d="M587.34 125.52L623.1 106.8C629.01 119.61 640.83 127.16 657.58 127.16C673.01 127.16 678.92 122.24 678.92 115.34C678.92 90.3401 594.21 105.49 594.21 48.3401C594.21 16.8201 621.79 0.0800781 655.93 0.0800781C681.87 0.0800781 704.85 11.5701 717.33 32.9101L681.89 51.6601C676.64 41.1501 666.79 35.2401 654.31 35.2401C642.17 35.2401 636.25 39.5101 636.25 46.7301C636.25 71.0301 720.96 55.6001 720.96 113.73C720.96 143.94 696.34 162.32 656.61 162.32C622.79 162.29 599.15 151.13 587.34 125.52Z"
        fill="#0056D2"
      />
      <path
        d="M0 81.5401C0 36.7301 36.63 0.740076 82.43 0.740076C96.2008 0.643555 109.779 3.97498 121.942 10.4341C134.104 16.8933 144.468 26.2771 152.1 37.7401L117.76 57.6601C113.787 51.9821 108.498 47.3502 102.346 44.16C96.1932 40.9698 89.3602 39.316 82.43 39.3401C58.88 39.3401 39.58 58.9701 39.58 81.5401C39.58 104.11 58.88 123.74 82.43 123.74C89.687 123.787 96.835 121.974 103.192 118.472C109.548 114.971 114.901 109.899 118.74 103.74L152.74 124.02C145.201 135.818 134.798 145.516 122.501 152.209C110.203 158.903 96.411 162.374 82.41 162.3C36.63 162.34 0 125.66 0 81.5401Z"
        fill="#0056D2"
      />
    </svg>
  )
}

export default Logotype
